import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { API } from '../api';

const UserCtx = createContext(null);

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('aegis_user_token');
    if (!token) { setReady(true); return; }
    try {
      const r = await API.get('/user/me', { headers: { Authorization: `Bearer ${token}` } });
      setUser(r.data);
    } catch { localStorage.removeItem('aegis_user_token'); }
    finally { setReady(true); }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const r = await API.post('/user/login', { email, password });
    localStorage.setItem('aegis_user_token', r.data.token);
    setUser({ email: r.data.email, name: r.data.name, is_admin: r.data.is_admin });
    return r.data;
  };
  const register = async (name, email, password) => {
    const r = await API.post('/user/register', { name, email, password });
    localStorage.setItem('aegis_user_token', r.data.token);
    setUser({ email: r.data.email, name: r.data.name, is_admin: r.data.is_admin });
    return r.data;
  };
  const logout = () => { localStorage.removeItem('aegis_user_token'); setUser(null); };
  const authHeader = () => {
    const t = localStorage.getItem('aegis_user_token');
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  return <UserCtx.Provider value={{ user, ready, login, register, logout, authHeader }}>{children}</UserCtx.Provider>;
}

export const useUserAuth = () => {
  const c = useContext(UserCtx);
  if (!c) throw new Error('UserAuthProvider missing');
  return c;
};
